import {
  AssignJobCatalogTreeNodeAttributesDocument,
  AssignJobCatalogTreeNodeAttributesMutation,
  JobCatalogEnumsJobCatalogTreeAttributeTypesEnum,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { Competency } from 'modules/competencies/components/CompetenciesFinder'
import { getChildNodeType, getNodeId, getNodeType } from 'modules/job_catalog/lib/nodesUtils'

export const serializeCompetency = (competency: Competency) => {
  const base = `{\"attribute_id\":\"${competency.id}\", \"title\":\"${competency.name}\"`

  if (competency.description) {
    return `${base},\"description\":\"${competency.description}\"}`
  }

  return `${base}}`
}

export const serializeSalary = (salary: SalaryToSerialize) => JSON.stringify(salary)

type SalaryToSerialize = {
  min?: string
  max?: string
  gross?: string
  currency: string
}

const useAssignJobCatalogTreeNodeAttributes = () => {
  const [mutate, { loading }] = useMutation(AssignJobCatalogTreeNodeAttributesDocument, {
    extractorFn: (data: AssignJobCatalogTreeNodeAttributesMutation) =>
      data.jobCatalogMutations.bulkAssignJobcatalogNodeAttribute,
  })

  const assignAttributes = (
    attributeType: JobCatalogEnumsJobCatalogTreeAttributeTypesEnum,
    companyId: number,
    nodeUuid: string,
    attributesJson: string[]
  ) => {
    const nodeId = getNodeId(nodeUuid)
    const nodeType = getNodeType(nodeUuid)
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        companyId,
        nodeUuid,
        attributeType,
        attributesJson,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            //TODO: This query will use nodeUuid in the next refactor
            nodeId,
            nodeType,
            childType,
          },
        },
      ],
    })
  }

  return { assignAttributes, loading }
}

export default useAssignJobCatalogTreeNodeAttributes
